import styled from 'styled-components'

export const FigureHome = styled.figure`
max-width: max-content;
margin-inline: auto;

@media (min-width: 992px) {
  position: relative;
  padding-inline-end: 50px;
  margin-block-start: 180px;
}
`


export const FigureAbout = styled.figure`
  max-width: max-content;
  padding-bottom: 45px;

  @media (min-width: 575px) {
    position: relative;
  }
  
  @media (min-width: 768px) {
    margin-inline: 120px 130px;
  }
  @media (min-width: 1200px) {
    margin-inline-start: -30px;
  }
`